<template>
  <div class="time_management">
    <div class="query_wapper">
      <div class="query_item">
        <el-button style="width:150px" @click="openModal">新建管理</el-button>
      </div>
    </div>
    <el-table style="width:1062px;margin-top:20px" border :data="tableData">
      <el-table-column width="60" type="index" label="序号" align="center"></el-table-column>
      <el-table-column width="200" label="角色" align="center">
        <template slot-scope="{row}">
          <span>{{row.type === 1?'运动员':row.type === 2?'教练':'裁判'}}</span>
        </template>
      </el-table-column>
      <el-table-column width="200" label="注册开始时间" align="center">
        <template slot-scope="{row}">
          <span>{{formats(row.startDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="200" label="注册结束时间" align="center">
        <template slot-scope="{row}">
          <span>{{formats(row.endDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="200" label="状态" align="center">
        <template slot-scope="{row}">
          <el-switch
            :disabled="row.endDate > row.nowDate?false:true"
            @change="$event=>stateChange($event,row.id)"
            :active-value="1"
            :inactive-value="0"
            v-model="row.state"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" align="center">
        <template slot-scope="{row}">
          <span
            style="color:#1CC28C;cursor:pointer"
            v-if="row.endDate > row.nowDate"
            @click="edit(row)"
          >编辑</span>
          <span style="color:#FD6666" v-else>已结束</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin:40px 0 0 420px"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.init)"
      @current-change="$event=>numberChange($event,this.init)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <el-dialog
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      center
      :title="title"
      width="600px"
      :visible.sync="modals"
      @close="closeModals"
    >
      <div class="blocks">
        <p>{{query.type === 1?'运动员':query.type === 2?'教练员':'裁判员'}}注册时间设置：</p>
        <el-form :model="query" ref="form" :rules="rules" label-width="120px">
          <el-form-item label="注册开始时间" prop="startDate">
            <el-date-picker
              v-model="query.startDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="注册结束时间" prop="endDate">
            <el-date-picker
              v-model="query.endDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="submitLoading"
          style="width:90px;margin-right:20px;border-color:#1E63B0;color:#1E63B0;"
          @click="handleSubmit"
        >确 定</el-button>
        <el-button style="width:90px;
background: #1E63B0;color:#fff" @click="modals =false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { table, message, page } from "@/common/js/mixins.js";
import {
  list,
  saveDate,
  isRegist,
  updateStates
} from "@/api/time-management.js";
import { getSession } from "@/utils/storage";
import { method } from "@/utils/utils";
const startValidate = (rule, value, callback) => {
  if (!value) return new Error(callback("注册开始时间不能为空"));
  callback();
};
const endValidate = (rule, value, callback) => {
  if (!value) return new Error(callback("注册结束时间不能为空"));
  callback();
};
export default {
  mixins: [table, message, page],
  data() {
    return {
      query: {
        id: "",
        endDate: "",
        startDate: "",
        type: 0
      },
      rules: {
        startDate: [
          {
            type: "date",
            required: true,
            validator: startValidate,
            trigger: "change"
          }
        ],
        endDate: [
          {
            type: "date",
            required: true,
            validator: endValidate,
            trigger: "change"
          }
        ]
      },
      isRegistState: false,
      title: "",
      submitLoading: false,
      modals: false,
      userInfo: JSON.parse(getSession("userInfo")) || null
    };
  },
  computed: {
    formats() {
      return data => {
        return method.timeFormat(data, "", 1);
      };
    }
  },
  methods: {
    // 列表状态修改
    stateChange(value, id) {
      updateStates({
        id,
        state: value
      })
        .then(res => {
          this.openSuccess("状态修改成功");
          this.init();
        })
        .catch(err => {});
    },
    // 编辑
    edit(data) {
      this.title = "修改注册时间";
      this.modals = true;
      let { id, type, startDate, endDate } = data;
      this.$nextTick(() => {
        Object.assign(this.query, {
          id,
          type,
          startDate: method.timeFormat(startDate, null, 1),
          endDate: method.timeFormat(endDate, null, 1)
        });
      });
    },
    // 监听弹窗关闭
    closeModals() {
      this.submitLoading = false;
      this.$refs["form"].resetFields();
    },
    // 提交/修改
    handleSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (
            new Date(this.query.startDate).getTime() >=
            new Date(this.query.endDate).getTime()
          ) {
            return this.openWarn("注册开始时间不能超过结束时间！");
          }
          this.submitLoading = true;
          saveDate({
            ...this.query
          })
            .then(res => {
              this.submitLoading = false;
              this.modals = false;
              this.openSuccess("设置成功！");
              this.init();
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // 获取数据
    getList() {
      let { currentRole } = this.userInfo;
      list({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        type: currentRole === 1 ? 2 : currentRole === 2 ? 1 : currentRole
      })
        .then(res => {
          this.tableData = [...res.list];
          this.total = res.total;
        })
        .catch(err => {});
    },
    // 打开弹窗
    openModal() {
      let { currentRole } = this.userInfo;
      isRegist({
        type: currentRole === 1 ? 2 : currentRole === 2 ? 1 : currentRole
      }).then(res => {
        if (res)
          return this.openWarn("注册时间未结束，请在时间结束后进行操作");
        let { currentRole } = this.userInfo;
        this.title = "添加注册时间";
        switch (currentRole) {
          case 1: {
            this.query.type = 2;
            break;
          }
          case 2: {
            this.query.type = 1;
            break;
          }
          default: {
            this.query.type = currentRole;
          }
        }
        this.modals = true;
      });
    },
    // 获取是否可以注册
    getIsRegist() {
      let { currentRole } = this.userInfo;
      isRegist({
        type: currentRole === 1 ? 2 : currentRole === 2 ? 1 : currentRole
      })
        .then(res => {
          this.isRegistState = res;
        })
        .catch(err => {});
    },
    init() {
      this.getIsRegist();
      this.getList();
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less" scoped>
.time_management {
  .blocks {
    padding-left: 80px;
    > p {
      font-size: 17px;
      color: #222;
      margin: 0 0 20px 20px;
    }
  }
  /deep/ .el-dialog__footer {
    padding-bottom: 40px;
  }
}
</style>